import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import '../Utility/Normalize.js';
import { SvgWrapper } from '../Utility/SvgWrapper.js';
import '../Utility/UnstyledList.js';

const Checkbox = forwardRef(function Checkbox(props, ref) {
    return (jsx(SvgWrapper, Object.assign({ fill: "none", height: "20", viewBox: "0 0 20 20", width: "20" }, props, { ref: ref, children: jsx("path", { d: "M5 2H15V-2H5V2ZM18 5V15H22V5H18ZM15 18H5V22H15V18ZM2 15V5H-2V15H2ZM5 18C3.34315 18 2 16.6569 2 15H-2C-2 18.866 1.13401 22 5 22V18ZM18 15C18 16.6569 16.6569 18 15 18V22C18.866 22 22 18.866 22 15H18ZM15 2C16.6569 2 18 3.34315 18 5H22C22 1.13401 18.866 -2 15 -2V2ZM5 -2C1.13401 -2 -2 1.13401 -2 5H2C2 3.34315 3.34315 2 5 2V-2Z", fill: "currentColor" }) })));
});

export { Checkbox as default };
//# sourceMappingURL=Checkbox.js.map
